import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";

import LoadingSpinner from "../../ui/loadingSpinner";
import {setGalleryActiveImageIndex, toggleGalleryVisible} from "../../../actions/selectionFunctions";
import {featureThumbnailUrl} from "../../../misc/helpers";
import {THUMBNAIL_SIZES} from "../../../misc/utils";
import Analytics from '../../../analytics';

const FeatureInfoImage = (props) => {

  const {selectionFeatureInfo, productNoteEditorVisible} = props;
  const [isLoading, toggleLoader] = useState(true);
  const [galleryImages, setGalleryImages] = useState([]);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    let featureGalleryImages = (selectionFeatureInfo.dbFeature.galleryEnabled && Array.isArray(selectionFeatureInfo.dbFeature.galleryImages)
      && selectionFeatureInfo.dbFeature.galleryImages.length) ? selectionFeatureInfo.dbFeature.galleryImages : [];
    toggleLoader(true);
    setGalleryImages([{
      url: featureThumbnailUrl(selectionFeatureInfo),
      preview: featureThumbnailUrl(selectionFeatureInfo, THUMBNAIL_SIZES.medium)
    },  // main image thumbnail
      ...featureGalleryImages
    ])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionFeatureInfo]);

  const changeImage = (index) => {
    if (index !== activeImageIndex) {
      toggleLoader(true);
      setActiveImageIndex(index)
    }
  };

  const thumbnailClick = (index) => {
    Analytics.sendClickEvent('gallery-image-thumbnail-clicked');
    props.toggleGalleryVisible(true);
    props.setGalleryActiveImageIndex(index);
  };

  const mainImageUrl = galleryImages[activeImageIndex];

  return (
    <div className={"product-image" + (productNoteEditorVisible ? " product-wrapper--inactive"  : "")}>
      {galleryImages.length > 1 ? (
        <ul className={"product-image__gallery"
        + (galleryImages.length > 3 ? " product-image__gallery--more-that-three" : "")
        + (galleryImages.length > 6 ? " product-image__gallery--more-that-six" : "")}>
          {galleryImages.map((gImg, index) => {
            return <li className={"product-image__gallery-image" + (activeImageIndex === index ? " product-image__gallery-image--active" : "")}
                       key={index}
                       style={{backgroundImage: "url('" + (gImg.preview || gImg.url) + "')"}}
                       onMouseOver={() => changeImage(index)}
                       onClick={() => thumbnailClick(index)} />
          })}
        </ul>
      ) : null}
      <div className="product-image__main">
        {isLoading || !mainImageUrl ? <LoadingSpinner/> : null}
        {mainImageUrl ? <img className={"product-image__main-image" + (isLoading ? " product-image__main-image--loading" : "")}
                             onClick={() => thumbnailClick(activeImageIndex)}
                             src={mainImageUrl.url} onLoad={() => toggleLoader(false)} alt=""/> : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {selectionFeatureInfo, productNoteEditorVisible} = store.selectionState;
  return {
    selectionFeatureInfo,
    productNoteEditorVisible,
    windowWidth: store.serverState.windowWidth,
  };
};

export default connect(mapStateToProps, {
  toggleGalleryVisible,
  setGalleryActiveImageIndex
})(FeatureInfoImage);
